import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {gsap} from "gsap";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-12-02.
 */

export class BenjiKIVOverlayScatterReSpinResultRunner implements SimplePresentation {

    protected _randomOverlayAnimationComplete:boolean = false;
    protected _serverResponse:boolean = false;
    protected _controller:SimplePresentationRunnerController;

    public shouldRun():boolean {
        this._serverResponse = true;
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        controller.setSkipCallback(() => this.skip());
        this.checkStart();
    }

    private checkStart():void {
        if(this._randomOverlayAnimationComplete == true) {
            if(this._serverResponse == true) {
                this._serverResponse = false;
                this._randomOverlayAnimationComplete = false;
                const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => this.complete()});
                tl.add(BenjiKIV.overlayScatterView.getAnimateAllToTargetTL());
                tl.add(() => {BenjiKIV.enhancerView.getDarkDownAllEnhancerPositions()});
            } else {
                BenjiKIV.overlayScatterView.doNoEndRandomAnimation();
            }
        }
    }

    protected skip():void {
        this._controller.setSkipCallback();
        //This will stop the overlay animations
        if (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN){
            BenjiKIV.respinOverlayRunner.skip();
        }else if (BenjiKIV.xBetView.boosted02Enabled == true && BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL){
            BenjiKIV.normalBoostedOverlayRunner.skip();
        }
    }

    private complete():void {
        this._controller.finish();
    }

    set randomOverlayAnimationComplete(value:boolean) {
        this._randomOverlayAnimationComplete = value;
        this.checkStart();
    }
}